import React, { Fragment } from "react";
import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import i18n from "i18next";

import { hasUserAtLeastOneRole } from "../../../helpers/Authorization/authorizationHelpers";
import SidePanel from "./SidePanel";

const PanelMobileNavigationMenu = ({ isMenuVisible, isMobile, onBackButtonClick }) => {
  const hasAtLeastOneRole = hasUserAtLeastOneRole();

  return (
    <SidePanel position="left" isVisible={isMobile && isMenuVisible} panelVisibility={onBackButtonClick} isMobile={isMobile}>
      <div className="panel-header__dock">
        {hasAtLeastOneRole && (
          <Fragment>
            <UISref to="advanced-search">
              <a className="navbar__link">{i18n.t("navbar.advancedSearch")}</a>
            </UISref>
            <hr className="panel-header__menu-line" />
            <UISref to="user-preferences">
              <a className="navbar__link">{i18n.t("navbar.setting")}</a>
            </UISref>
            <hr className="panel-header__menu-line" />
            <UISref to="help">
              <a className="navbar__link">{i18n.t("navbar.help")}</a>
            </UISref>
            <hr className="panel-header__menu-line" />
            <UISref to="contact-us">
              <a className="navbar__link">{i18n.t("navbar.contactUs")}</a>
            </UISref>
            <hr className="panel-header__menu-line" />
          </Fragment>
        )}
        <UISref to="logout">
          <a className="navbar__link">{i18n.t("navbar.logout")}</a>
        </UISref>
      </div>
    </SidePanel>
  );
};

PanelMobileNavigationMenu.propTypes = {
  isMenuVisible: PropTypes.bool,
  isMobile: PropTypes.bool,
  onBackButtonClick: PropTypes.func
};

PanelMobileNavigationMenu.defaultProps = {
  isMenuVisible: false,
  isMobile: false,
  onBackButtonClick: null
};

export default PanelMobileNavigationMenu;



// WEBPACK FOOTER //
// ./src/components/Layout/Panel/PanelMobileNavigationMenu.js